import { render, staticRenderFns } from "./SubGovernanceDetail.vue?vue&type=template&id=768ef83f&scoped=true&"
import script from "./SubGovernanceDetail.vue?vue&type=script&lang=js&"
export * from "./SubGovernanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubGovernanceDetail.vue?vue&type=style&index=0&id=768ef83f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ef83f",
  null
  
)

export default component.exports